import * as React from 'react'
import { Modal, Button } from 'antd'
import { ComponentExt } from 'util/reactExt'
import TestCard from '../TestCard'
import ExamCard from '../ExamCard'

export interface TestListModalProps {
  showModal?: boolean
  closeModal?: (pass, content?) => void
  data: any
  isVideo?: boolean
  onRef: any
  onProgressChanged?: (val: string) => void
}

export interface TestListModalState {
  titles: any[]
  completedTitleNum: number
  examAnswerMap: any[]
}

export default class TestListModal extends ComponentExt<
  TestListModalProps,
  TestListModalState
> {
  examAnswerMap: any[]
  type: string
  completeTest: boolean = false
  constructor(props: TestListModalProps) {
    super(props)

    const {
      data: { check_task },
    } = props

    this.type = check_task.type

    const titles =
      check_task.type === '考试'
        ? check_task.exam_titles
        : check_task.example_titles

    this.examAnswerMap = titles.map(title => ({
      title_id: title.id,
      answers: [''],
    }))

    this.state = {
      titles,
      completedTitleNum: 0,
      examAnswerMap: [],
    }
  }

  componentDidMount() {
    this.props.onRef && this.props.onRef(this)
  }

  toggleComplete = () => {
    this.completeTest = true
  }

  handleComplete = async e => {
    e.preventDefault()
    const status = !this.props.isVideo && this.completeTest
    // this.props.closeModal(status)
  }

  handleSubmit = async () => {
    // e.preventDefault()
    const {
      check_task: { exam_titles },
      meta: { check_is_passed, check_message },
    } = await this.api.level.submitExamPaper(
      this.props.data.id,
      this.state.examAnswerMap,
    )

    return {
      isPassed: check_is_passed,
      content: exam_titles,
    }
    // this.props.closeModal(check_is_passed, exam_titles)
  }

  handlePostAnwser = (index, answer) => {
    const { onProgressChanged } = this.props
    this.examAnswerMap[index].answers = answer
    const completedTitleNum = this.examAnswerMap.filter(item => item.answers[0])
      .length
    if (onProgressChanged) {
      onProgressChanged(`
        ${completedTitleNum}/${this.examAnswerMap.length}`)
    }

    this.setState({
      completedTitleNum,
      examAnswerMap: this.examAnswerMap,
    })
  }

  public render() {
    const isExam = this.type === '考试'
    return (
      <div>
        {Array.isArray(this.state.titles) &&
          this.state.titles.map((x, idx) =>
            isExam ? (
              <ExamCard
                key={x.id}
                index={idx + 1}
                {...x}
                onPostAnwser={this.handlePostAnwser}
              />
            ) : (
              <TestCard
                key={x.id}
                index={idx + 1}
                {...x}
                exerciseid={this.props.data.id}
                answerApi={this.api.level.postTitleAnswers}
                onPostAnwser={this.handlePostAnwser}
                onPostComplete={this.toggleComplete}
              />
            ),
          )}
      </div>
    )
  }
}
